import actions from '../actions';
import { APP_INIT, CUSTOM_TOKEN_ADDED } from '../actionTypes';

const handleLocalTokens = (storage, beforeState, afterState, action, store) => {
  if (action.type === APP_INIT) {
    store.dispatch(actions.tokensLocallyLoaded(storage.get('localTokenList') || afterState.token.localTokenList));
  }

  if (action.type === CUSTOM_TOKEN_ADDED) {
    storage.set('localTokenList', {
      ...(storage.get('localTokenList') || {}),
      ...afterState.token.localTokenList,
    });
  }
};

export default handleLocalTokens;



// WEBPACK FOOTER //
// ./src/middleware/localTokensPersistence.js